import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@/services/api';

export const useProjectCreate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: any) => {
      const res = await request.post('/course-project', data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['project-list'] });
    }
  });
};

export const useProjectUpdate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: any }) => {
      const res = await request.patch(`/course-project/${id}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['project-list'] });
    }
  });
};

export const useProjectDelete = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const res = await request.delete(`/course-project/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['project-list'] });
    }
  });
};

export const useCourseProjectCreate = useProjectCreate;
export const useCourseProjectUpdate = useProjectUpdate;
export const useCourseProjectDelete = useProjectDelete;
